import styled, { css } from 'styled-components'
import React from 'react'

export const ElectronicDocumentInfo = styled.dl`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: -10px;
  }

  dt,
  dd {
    padding: 0.5rem 0;
    margin-bottom: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  dt {
    width: 160px;
    font-weight: 700;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  dt:after {
    content: ':';
  }

  .no-two-dots {
    &:after {
      display: inline-block;
      content: '';
    }
  }

  dd {
    width: calc(100% - 170px);
    word-break: break-all;

    &:last-child {
      border-bottom: none;
    }
  }
`
export const ViewerWrapper = styled.div`
  min-height: 89vh;
  height: 100%;
  overflow-x: hidden;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  flex-grow: 1;
  ${props =>
    props.fullHeight === null &&
    css`
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    `}
`

export const CanvasDocWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  @media screen and (max-width: 1299px) {
    flex-direction: column;
  }
`

export const BlockRight = styled.div`
  width: 380px;
  @media screen and (max-width: 1299px) {
    width: 100%;
  }
`

export const CanvasDocHeader = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 20px;
  margin-bottom: 15px;
  margin-top: 6px;
  align-items: flex-start;
  @media screen and (max-width: 1299px) {
    display: block;
  }

  @media screen and (min-width: 1300px) and (max-width: 1455px) {
    flex-wrap: wrap;
    row-gap: 10px;
  }
`
export const ButtonItem = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 380px;
  max-width: 380px;

  .ant-btn {
    width: calc(340px);
  }

  .ant-dropdown-trigger {
    width: 32px;
  }

  @media screen and (max-width: 1299px) {
    margin-bottom: 10px;
    max-width: 100vw;
    display: flex;
    justify-content: center;
  }
`

/** Badge số lần trả về chỉnh sửa — gọn trong Thông tin chung */
export const RollbackCountBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  background: ${props => (props.$danger ? '#fff1f0' : '#fff7e6')};
  color: ${props => (props.$danger ? '#cf1322' : '#d46b08')};
  border: 1px solid ${props => (props.$danger ? '#ffccc7' : '#ffd591')};
`

export const RollbackCountValue = styled.span`
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
`

/** Banner khóa luồng — thay Alert antd cho gọn */
export const FlowLockedBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px 16px;
  margin-bottom: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #fff1f0;
  border: 1px solid #ffccc7;
`

export const FlowLockedContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
`

export const FlowLockedIcon = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-top: 1px;
  border-radius: 8px;
  background: #ffccc7;
  color: #a8071a;
  font-size: 14px;
`

export const FlowLockedText = styled.div`
  min-width: 0;
`

export const FlowLockedTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #a8071a;
  line-height: 1.35;
`

export const FlowLockedDesc = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: #820014;
  opacity: 0.85;
  line-height: 1.45;
`

export const FlowLockedAction = styled.div`
  flex-shrink: 0;

  .ant-btn {
    height: 32px;
    padding: 0 14px;
    font-size: 13px;
    border-radius: 6px;
  }

  @media screen and (max-width: 900px) {
    width: 100%;

    .ant-btn {
      width: 100%;
    }
  }
`
